/**
 * Rutas que NO deben ser usadas para redirección después del login
 * Si el usuario estaba en una de estas rutas antes de login, se redirige a la raíz
 */
const EXCLUDED_REDIRECT_ROUTES = [
  '/register',
  '/password-recovery',
  '/delete-account',
  '/credential-validation',
  '/socialmedialink'
];

/**
 * Valida si una ruta es válida para redirección después del login
 * @param {string} path - La ruta a validar
 * @returns {boolean} - true si la ruta es válida para redirección, false si no
 */
export const isValidRedirectPath = (path) => {
  if (!path || path === '/') return false;
  
  // Normalizar la ruta
  const normalizedPath = path.toLowerCase().trim();
  
  // Verificar si la ruta está en la lista de exclusiones
  return !EXCLUDED_REDIRECT_ROUTES.some(route => 
    normalizedPath === route || normalizedPath.startsWith(route + '/')
  );
};

/**
 * Obtiene la ruta de redirección válida después del login
 * Si la ruta guardada no es válida, retorna la ruta por defecto ('/')
 * @param {string} savedPath - La ruta guardada en sessionStorage o searchParams
 * @param {string} defaultPath - La ruta por defecto si no hay ruta válida (default: '/')
 * @returns {string} - La ruta a la que se debe redirigir
 */
export const getValidRedirectPath = (savedPath, defaultPath = '/') => {
  if (!savedPath) return defaultPath;
  
  return isValidRedirectPath(savedPath) ? savedPath : defaultPath;
};
